import type { Space } from '@mail/cross-sizes-utils';
import clsx from 'clsx';
import React from 'react';

import styles from './TariffSpace.css';

export function TariffSpace({ className, tariffSpace }: { className?: string; tariffSpace: Space }) {
    return (
        <div className={clsx(styles.root, className)}>
            <span className={styles.tariffSpace}>{tariffSpace.space}</span>
            <span className={styles.tariffUnits}>{tariffSpace.units}</span>
        </div>
    );
}
